(function () {
  /**
   * SET THIS CORRECTLY:
   * Go to /admin/themes -> Edit code -> sections
   * Find the section file that contains "scd__wrapper" or "scd__items"
   * Example: sections/cart-drawer.liquid => "cart-drawer"
   */
  var DRAWER_SECTION = "cart-drawer"; // <-- change if your file name differs

  function replaceFromNewHTML(selector, newDoc) {
    var current = document.querySelector(selector);
    var fresh = newDoc.querySelector(selector);
    if (current && fresh) current.replaceWith(fresh);
  }

  async function fetchSectionHTML() {
    var res = await fetch("/?sections=" + encodeURIComponent(DRAWER_SECTION), {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    });

    if (!res.ok) throw new Error("Section fetch failed");

    var data = await res.json();
    var html = data[DRAWER_SECTION];
    if (!html) throw new Error("Section HTML missing: " + DRAWER_SECTION);

    return new DOMParser().parseFromString(html, "text/html");
  }

  async function refreshDrawerAndUpsell() {
    var doc = await fetchSectionHTML();

    // MiniMog drawer parts (update these if your theme uses different selectors)
    replaceFromNewHTML(".scd__items", doc);
    replaceFromNewHTML("[data-cart-summary]", doc);
    replaceFromNewHTML(".scd__header", doc);

    // IMPORTANT: also refresh upsell block (so added item disappears via Liquid rule)
    replaceFromNewHTML("[data-upsell]", doc);

    // If your theme has cart bubble, add its selector too (optional)
    // replaceFromNewHTML(".sf-cart-count", doc);
  }

  async function ajaxAddVariant(variantId) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!res.ok) {
      var err;
      try { err = await res.json(); } catch (e) {}
      throw err || new Error("Add to cart failed");
    }

    return res.json();
  }

  function removeUpsellSlideInstant(btn) {
    var slide = btn.closest("[data-upsell-item]");
    if (slide) slide.remove();
  }

  // CLICK handler (NOT submit) to avoid theme conflicts
  document.addEventListener("click", async function (e) {
    var addBtn = e.target.closest("[data-upsell-add]");
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // prevent double click
    if (addBtn.dataset.loading === "1") return;
    addBtn.dataset.loading = "1";
    addBtn.disabled = true;

    try {
      var form = addBtn.closest("[data-upsell-form]");
      var input = form ? form.querySelector('input[name="id"]') : null;
      var variantId = input ? input.value : null;

      if (!variantId) throw new Error("Missing variant id");

      // 1) Add product immediately
      await ajaxAddVariant(variantId);

      // 2) Remove slide immediately (instant UI feedback)
      removeUpsellSlideInstant(addBtn);

      // 3) Refresh drawer + upsell markup from server (actual cart state)
      await refreshDrawerAndUpsell();

      // keep drawer open
      var wrapper = document.querySelector(".scd__wrapper");
      if (wrapper) wrapper.classList.remove("hidden");
    } catch (err) {
      console.error("Upsell add error:", err);
      alert("Could not add the product. Please try again.");
    } finally {
      addBtn.disabled = false;
      addBtn.dataset.loading = "0";
    }
  });

  // Slider arrows (optional — keep if you have arrows)
  document.addEventListener("click", function (e) {
    var prevBtn = e.target.closest("[data-upsell-prev]");
    var nextBtn = e.target.closest("[data-upsell-next]");
    if (!prevBtn && !nextBtn) return;

    var root = (prevBtn || nextBtn).closest("[data-upsell]");
    var track = root ? root.querySelector("[data-upsell-track]") : null;
    if (!track) return;

    e.preventDefault();

    // step = 1 slide (assumes 100% width slide). If you use different widths, tell me and I'll adjust.
    var step = track.getBoundingClientRect().width;
    track.scrollBy({ left: nextBtn ? step : -step, behavior: "smooth" });
  });
})();
